import { Controller } from "@hotwired/stimulus"

// Appendix B §1: hides the floating WhatsApp widget while #form-section is in
// the viewport on screens narrower than 1024px, so it never obstructs the form.
export default class extends Controller {
  static values = { targetId: String }

  connect() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.05
    })

    const target = document.getElementById(this.targetIdValue)
    if (target) {
      this.observer.observe(target)
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleIntersect(entries) {
    // Appendix B §1: the widget never obstructs #form-section. Measured geometry
    // showed the tooltip and labeled button overlap the form card at every
    // desktop width (1024-1440), so the form-in-view hiding applies at all widths.
    const entry = entries[0]
    if (entry && entry.isIntersecting) {
      this.element.classList.add("opacity-0", "pointer-events-none", "invisible")
    } else {
      this.element.classList.remove("opacity-0", "pointer-events-none", "invisible")
    }
  }
}
